// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-scroll {
  overflow: hidden;
}

.welcome-section {
  width: 100%;
  height: calc(100svh - 92px);
  padding-top: 92px;
  color: #FFFFFF;
  background-color: #982D67;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1620px) {
  .welcome-section {
    height: calc(100svh - 100px);
    padding-top: 100px;
  }
}
@media (max-width: 550px) {
  .welcome-section {
    height: calc(100svh - 80px);
    padding-top: 80px;
  }
}
.welcome-section .welcome-section-container {
  width: calc(100% - 160px);
  height: 100%;
  position: relative;
  overflow: hidden;
}
@media (min-width: 1620px) {
  .welcome-section .welcome-section-container {
    width: calc(100% - 200px);
  }
}
@media (max-width: 1050px) {
  .welcome-section .welcome-section-container {
    width: calc(100% - 80px);
  }
}
@media (max-width: 550px) {
  .welcome-section .welcome-section-container {
    width: calc(100% - 32px);
  }
}
.welcome-section .welcome-section-container .welcome-section-lottie-container {
  width: 1200px;
  height: 100%;
  transform-origin: center center;
  position: absolute;
  z-index: 20;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%) translateY(0) scale(1);
  transition: transform 1.5s ease-in-out;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.welcome-section .welcome-section-container .welcome-section-lottie-container svg {
  max-width: 100% !important;
  transform: unset !important;
}
@media (max-width: 1150px) {
  .welcome-section .welcome-section-container .welcome-section-lottie-container {
    width: 1000px;
    bottom: 0;
  }
}
@media (max-width: 950px) {
  .welcome-section .welcome-section-container .welcome-section-lottie-container {
    width: 900px;
  }
}
@media (max-width: 750px) {
  .welcome-section .welcome-section-container .welcome-section-lottie-container {
    width: 700px;
  }
}
@media (max-width: 650px) {
  .welcome-section .welcome-section-container .welcome-section-lottie-container {
    width: 600px;
  }
}
@media (max-width: 550px) {
  .welcome-section .welcome-section-container .welcome-section-lottie-container {
    width: 500px;
    bottom: -6%;
  }
}
@media (max-width: 450px) {
  .welcome-section .welcome-section-container .welcome-section-lottie-container {
    width: 100%;
    height: 80%;
    bottom: 20%;
  }
  .welcome-section .welcome-section-container .welcome-section-lottie-container.scale-modile {
    width: 250%;
    transform: translateX(-50%) translateY(0) scale(3);
  }
}
.welcome-section .welcome-section-container .welcome-section-lottie-container.scale {
  transform: translateX(-50%) translateY(-7%) scale(4.5);
}
@media (max-width: 650px) {
  .welcome-section .welcome-section-container .welcome-section-lottie-container.scale {
    transform: translateX(-50%) translateY(-7%) scale(7);
  }
}
@media (max-width: 450px) {
  .welcome-section .welcome-section-container .welcome-section-lottie-container.scale {
    transform: translateX(-50%) translateY(22%) scale(3.8);
  }
}
.welcome-section .welcome-section-container .welcome-section-iddle-lottie {
  max-width: 100% !important;
  height: 100% !important;
}
.welcome-section .welcome-section-container .welcome-section-iddle-lottie svg {
  max-width: 100% !important;
  transform: unset !important;
}
.welcome-section .welcome-section-container .welcome-section-title {
  position: absolute;
  top: 69%;
  z-index: 30;
  white-space: nowrap;
  overflow: hidden;
  font-family: FixelDisplay;
  font-size: 300px;
  font-style: normal;
  font-weight: 400;
  line-height: 90%;
}
.welcome-section .welcome-section-container .welcome-section-title .char {
  opacity: 0;
  display: inline-block;
}
@media (min-width: 1620px) {
  .welcome-section .welcome-section-container .welcome-section-title {
    font-family: FixelDisplay;
    font-size: 400px;
    font-style: normal;
    font-weight: 400;
    line-height: 90%;
  }
}
@media (max-width: 550px) {
  .welcome-section .welcome-section-container .welcome-section-title {
    top: unset;
    bottom: 0;
    padding-bottom: 90px;
    transform-origin: bottom left !important;
  }
}
.welcome-section .welcome-section-container .welcome-section-title.visible {
  animation: visibleText 1s 2s forwards ease-in-out;
}
.welcome-section .welcome-section-container .welcome-section-subtitle {
  position: absolute;
  top: 48px;
  left: 50%;
  z-index: 30;
  transform: translateX(-50%);
  text-align: center;
  text-transform: uppercase;
  overflow: hidden;
  opacity: 0;
  animation: visibleText 1s 12s forwards ease-in-out;
  font-family: FixelDisplay;
  font-size: 32px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
}
@media (min-width: 1620px) {
  .welcome-section .welcome-section-container .welcome-section-subtitle {
    font-family: FixelDisplay;
    font-size: 40px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
  }
}
@media (max-width: 650px) {
  .welcome-section .welcome-section-container .welcome-section-subtitle {
    font-family: FixelDisplay;
    font-size: 25px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
  }
}
@media (max-width: 550px) {
  .welcome-section .welcome-section-container .welcome-section-subtitle {
    width: 100%;
    top: unset;
    bottom: 200px;
    font-family: FixelDisplay;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
  }
}
@media (max-width: 400px) {
  .welcome-section .welcome-section-container .welcome-section-subtitle {
    bottom: 150px;
  }
}
.welcome-section .welcome-section-container .welcome-section-subtitle .char {
  opacity: 0;
  display: inline-block;
}
.welcome-section .welcome-section-container .welcome-section-subtitle.visible {
  animation: visibleText 1s 2s forwards ease-in-out;
}
.welcome-section .welcome-section-container .progress-bar {
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #FFFFFF;
}
.welcome-section .welcome-section-container .progress-bar.top {
  top: 22%;
  transition: top 1s cubic-bezier(0.4, 0, 0.2, 1);
}
@media (max-width: 1150px) {
  .welcome-section .welcome-section-container .progress-bar.top {
    top: 35%;
  }
}
@media (max-width: 450px) {
  .welcome-section .welcome-section-container .progress-bar.top {
    top: 25%;
  }
}
.welcome-section .welcome-section-container .progress-bar.top.up-to-header {
  top: 0px;
}
.welcome-section .welcome-section-container .progress-bar.top.fixed {
  opacity: 0;
  transition: opacity 0s linear;
}
.welcome-section .welcome-section-container .progress-bar.bottom {
  bottom: 35%;
  transition: bottom 1s cubic-bezier(0.4, 0, 0.2, 1);
}
@media (max-width: 550px) {
  .welcome-section .welcome-section-container .progress-bar.bottom {
    bottom: 25%;
  }
}
@media (max-width: 450px) {
  .welcome-section .welcome-section-container .progress-bar.bottom {
    bottom: 45%;
  }
  .welcome-section .welcome-section-container .progress-bar.bottom.down-to-bottom {
    bottom: 20%;
  }
}
@media (max-width: 400px) {
  .welcome-section .welcome-section-container .progress-bar.bottom.down-to-bottom {
    bottom: 17%;
  }
}
.welcome-section .welcome-section-container .progress-bar-percentage {
  position: absolute;
  left: 0;
  bottom: 48px;
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
  font-family: FixelDisplay;
  font-size: 124px;
  font-style: normal;
  font-weight: 400;
  line-height: 90%;
}
@media (max-width: 550px) {
  .welcome-section .welcome-section-container .progress-bar-percentage {
    bottom: 30px;
    font-family: FixelDisplay;
    font-size: 50px;
    font-style: normal;
    font-weight: 400;
    line-height: 90%;
  }
}
.welcome-section .welcome-section-container .progress-bar-percentage.hidden {
  opacity: 0;
}
.welcome-section .welcome-section-container .welcome-section-star {
  position: absolute;
  bottom: 35%;
  transform: translateY(50%);
  background-color: #982D67;
}
@media (max-width: 550px) {
  .welcome-section .welcome-section-container .welcome-section-star {
    bottom: unset;
    top: 30px;
  }
}
.welcome-section .welcome-section-container .welcome-section-star img {
  animation: rotatingStar 8s linear infinite;
}
.welcome-section .welcome-section-container .welcome-section-star.left {
  left: -41px;
  padding-right: 16px;
}
@media (max-width: 550px) {
  .welcome-section .welcome-section-container .welcome-section-star.left {
    display: none;
  }
}
.welcome-section .welcome-section-container .welcome-section-star.left.visible {
  animation: visibleLeftStar 1s 1.5s forwards ease-in-out;
}
.welcome-section .welcome-section-container .welcome-section-star.right {
  right: -41px;
  padding-left: 16px;
}
.welcome-section .welcome-section-container .welcome-section-star.right.visible {
  animation: visibleRightStar 1s 1.5s forwards ease-in-out;
}
.welcome-section .welcome-section-container .welcome-section-benefits-box {
  width: 100%;
  position: absolute;
  top: 48px;
  opacity: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 550px) {
  .welcome-section .welcome-section-container .welcome-section-benefits-box {
    top: unset;
    bottom: 0;
    padding-bottom: 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}
.welcome-section .welcome-section-container .welcome-section-benefits-box.visible {
  animation: visibleText 1s 1s forwards ease-in-out;
}
.welcome-section .welcome-section-container .welcome-section-benefits-box .welcome-section-benefits-small-box {
  gap: 38px;
  text-transform: uppercase;
  letter-spacing: 0.08px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-family: FixelDisplay;
  font-size: 8px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
}
@media (max-width: 1300px) {
  .welcome-section .welcome-section-container .welcome-section-benefits-box .welcome-section-benefits-small-box {
    gap: 4px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
}
@media (max-width: 550px) {
  .welcome-section .welcome-section-container .welcome-section-benefits-box .welcome-section-benefits-small-box {
    display: none;
  }
}
.welcome-section .welcome-section-container .welcome-section-benefits-box .welcome-section-benefits-small-box .welcome-section-benefit {
  gap: 4px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.welcome-section .welcome-section-container .welcome-section-benefits-box .welcome-section-benefits-small-box-mobile {
  display: none;
}
.welcome-section .welcome-section-container .welcome-section-benefits-box .welcome-section-benefits-small-box-mobile .welcome-section-benefit {
  gap: 4px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 550px) {
  .welcome-section .welcome-section-container .welcome-section-benefits-box .welcome-section-benefits-small-box-mobile {
    width: 100%;
    display: block;
    text-transform: uppercase;
    letter-spacing: 0.08px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-family: FixelDisplay;
    font-size: 8px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
  }
}
.welcome-section .welcome-section-container .welcome-section-text-box {
  width: 100%;
  position: absolute;
  bottom: calc(35% + 21px);
  z-index: 21;
  opacity: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 550px) {
  .welcome-section .welcome-section-container .welcome-section-text-box {
    bottom: unset;
    top: 20px;
    gap: 12px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
}
.welcome-section .welcome-section-container .welcome-section-text-box.visible {
  animation: visibleText 1s 1s forwards ease-in-out;
}
.welcome-section .welcome-section-container .welcome-section-text-box .welcome-section-text-box-first {
  position: relative;
}
.welcome-section .welcome-section-container .welcome-section-text-box .welcome-section-text-box-first span {
  display: block;
  width: 74px;
  letter-spacing: 0.08px;
  text-transform: uppercase;
  font-family: FixelDisplay;
  font-size: 8px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
}
@media (min-width: 1620px) {
  .welcome-section .welcome-section-container .welcome-section-text-box .welcome-section-text-box-first span {
    width: 94px;
    font-family: FixelDisplay;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
  }
}
@media (max-width: 550px) {
  .welcome-section .welcome-section-container .welcome-section-text-box .welcome-section-text-box-first span {
    width: 100%;
  }
}
.welcome-section .welcome-section-container .welcome-section-text-box .welcome-section-text-box-first svg {
  position: absolute;
  bottom: 3px;
  left: 25px;
}
@media (min-width: 1620px) {
  .welcome-section .welcome-section-container .welcome-section-text-box .welcome-section-text-box-first svg {
    bottom: 4px;
    left: 29px;
  }
}
@media (max-width: 550px) {
  .welcome-section .welcome-section-container .welcome-section-text-box .welcome-section-text-box-first svg {
    display: none;
  }
}
.welcome-section .welcome-section-container .welcome-section-text-box .welcome-section-text-box-second {
  display: block;
  width: 221px;
  letter-spacing: 0.14px;
  text-transform: uppercase;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 50;
  font-family: FixelDisplay;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
}
@media (min-width: 1620px) {
  .welcome-section .welcome-section-container .welcome-section-text-box .welcome-section-text-box-second {
    width: 253px;
    font-family: FixelDisplay;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
  }
}
@media (max-width: 550px) {
  .welcome-section .welcome-section-container .welcome-section-text-box .welcome-section-text-box-second {
    position: static;
    width: 298px;
    font-family: FixelDisplay;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
  }
}

@keyframes visibleText {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes visibleLeftStar {
  from {
    left: -41px;
  }
  to {
    left: 0;
  }
}
@keyframes visibleRightStar {
  from {
    right: -41px;
  }
  to {
    right: 0;
  }
}
@keyframes rotatingStar {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/WelcomeSection/WelcomeSection.scss","webpack://./src/styles/variables.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AAGA;EACI,gBAAA;AAFJ;;AAKA;EACI,WAAA;EACA,2BAAA;EACA,iBAAA;EACA,cCRI;EDSJ,yBCVS;EDWT,kBAAA;EACA,UAAA;EEbA,aAAA;EACA,mBFaqB;EEZrB,uBFY0B;EEX1B,mBFWkC;AACtC;AACI;EAVJ;IAWQ,4BAAA;IACA,kBAAA;EAEN;AACF;AAAI;EAfJ;IAgBQ,2BAAA;IACA,iBAAA;EAGN;AACF;AADI;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAGR;AADQ;EANJ;IAOQ,yBAAA;EAIV;AACF;AAFQ;EAVJ;IAWQ,wBAAA;EAKV;AACF;AAHQ;EAdJ;IAeQ,wBAAA;EAMV;AACF;AAJQ;EACI,aAAA;EACA,YAAA;EACA,+BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kDAAA;EACA,sCAAA;EErDR,aAAA;EACA,mBFqD6B;EEpD7B,uBFoDkC;EEnDlC,mBFmD0C;AAS9C;AAPY;EACI,0BAAA;EACA,2BAAA;AAShB;AANY;EAjBJ;IAkBQ,aAAA;IACA,SAAA;EASd;AACF;AAPY;EAtBJ;IAuBQ,YAAA;EAUd;AACF;AARY;EA1BJ;IA2BQ,YAAA;EAWd;AACF;AATY;EA9BJ;IA+BQ,YAAA;EAYd;AACF;AAVY;EAlCJ;IAmCQ,YAAA;IACA,WAAA;EAad;AACF;AAXY;EAvCJ;IAwCQ,WAAA;IACA,WAAA;IACA,WAAA;EAcd;EAZc;IACI,WAAA;IACA,kDAAA;EAclB;AACF;AAXY;EACI,sDAAA;AAahB;AAXgB;EAHJ;IAIQ,oDAAA;EAclB;AACF;AAZgB;EAPJ;IAQQ,sDAAA;EAelB;AACF;AAXQ;EACI,0BAAA;EACA,uBAAA;AAaZ;AAVY;EACI,0BAAA;EACA,2BAAA;AAYhB;AARQ;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EAGA,mBAAA;EAEA,gBAAA;EEvHR,yBFyH6B;EExH7B,gBFwH2C;EEvH3C,kBFuHkD;EEtHlD,gBFsH0D;EErH1D,gBFqH+D;AAUnE;AARY;EACI,UAAA;EACA,qBAAA;AAUhB;AAPY;EAjBJ;IE/GJ,yBFiIiC;IEhIjC,gBFgI+C;IE/H/C,kBF+HsD;IE9HtD,gBF8H8D;IE7H9D,gBF6HmE;EAcrE;AACF;AAZY;EArBJ;IAsBQ,UAAA;IACA,SAAA;IACA,oBAAA;IACA,wCAAA;EAed;AACF;AAbY;EACI,iDAAA;AAehB;AAXQ;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,UAAA;EACA,kDAAA;EE1JR,yBF2J6B;EE1J7B,eF0J2C;EEzJ3C,kBFyJiD;EExJjD,gBFwJyD;EEvJzD,iBFuJ8D;AAiBlE;AAfY;EAbJ;IEhJJ,yBF8JiC;IE7JjC,eF6J+C;IE5J/C,kBF4JqD;IE3JrD,gBF2J6D;IE1J7D,iBF0JkE;EAsBpE;AACF;AApBY;EAjBJ;IEhJJ,yBFkKiC;IEjKjC,eFiK+C;IEhK/C,kBFgKqD;IE/JrD,gBF+J6D;IE9J7D,iBF8JkE;EA2BpE;AACF;AAzBY;EArBJ;IAsBQ,WAAA;IACA,UAAA;IACA,aAAA;IExKZ,yBFyKiC;IExKjC,eFwK+C;IEvK/C,kBFuKqD;IEtKrD,gBFsK6D;IErK7D,iBFqKkE;EAgCpE;AACF;AA9BY;EA5BJ;IA6BQ,aAAA;EAiCd;AACF;AA/BY;EACI,UAAA;EACA,qBAAA;AAiChB;AA9BY;EACI,iDAAA;AAgChB;AA5BQ;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,yBCnMJ;ADiOR;AA5BY;EACI,QAAA;EACA,+CAAA;AA8BhB;AA5BgB;EAJJ;IAKQ,QAAA;EA+BlB;AACF;AA7BgB;EARJ;IASQ,QAAA;EAgClB;AACF;AA1BgB;EACI,QAAA;AA4BpB;AAzBgB;EACI,UAAA;EACA,6BAAA;AA2BpB;AAvBY;EACI,WAAA;EACA,kDAAA;AAyBhB;AAvBgB;EAJJ;IAKQ,WAAA;EA0BlB;AACF;AAxBgB;EARJ;IASQ,WAAA;EA2BlB;EAzBkB;IACI,WAAA;EA2BtB;AACF;AAxBgB;EACI;IACI,WAAA;EA0BtB;AACF;AArBQ;EACI,kBAAA;EACA,OAAA;EACA,YAAA;EACA,UAAA;EACA,oCAAA;EEvPR,yBFwP6B;EEvP7B,gBFuP2C;EEtP3C,kBFsPkD;EErPlD,gBFqP0D;EEpP1D,gBFoP+D;AA2BnE;AAzBY;EARJ;IASQ,YAAA;IE3PZ,yBF4PiC;IE3PjC,eF2P+C;IE1P/C,kBF0PqD;IEzPrD,gBFyP6D;IExP7D,gBFwPkE;EAgCpE;AACF;AA9BY;EACI,UAAA;AAgChB;AA5BQ;EACI,kBAAA;EACA,WAAA;EACA,0BAAA;EACA,yBC9QC;AD4Sb;AA5BY;EANJ;IAOQ,aAAA;IACA,SAAA;EA+Bd;AACF;AA7BY;EACI,0CAAA;AA+BhB;AA5BY;EACI,WAAA;EACA,mBAAA;AA8BhB;AA5BgB;EAJJ;IAKQ,aAAA;EA+BlB;AACF;AA7BgB;EACI,uDAAA;AA+BpB;AA3BY;EACI,YAAA;EACA,kBAAA;AA6BhB;AA3BgB;EACI,wDAAA;AA6BpB;AAxBQ;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EErTR,aAAA;EACA,mBFqT6B;EEpT7B,8BFoTkC;EEnTlC,mBFmTiD;AA6BrD;AA3BY;EAPJ;IAQQ,UAAA;IACA,SAAA;IACA,oBAAA;IE3TZ,aAAA;IACA,mBF2TiC;IE1TjC,8BF0TsC;IEzTtC,mBFyTqD;EAiCvD;AACF;AA/BY;EACI,iDAAA;AAiChB;AA9BY;EACI,SAAA;EACA,yBAAA;EACA,sBAAA;EEtUZ,aAAA;EACA,mBFsUiC;EErUjC,8BFqUsC;EEpUtC,mBFoUqD;EEhUrD,yBFiUiC;EEhUjC,cFgU+C;EE/T/C,kBF+ToD;EE9TpD,gBF8T4D;EE7T5D,iBF6TiE;AAuCrE;AArCgB;EAPJ;IAQQ,QAAA;IE3UhB,aAAA;IACA,sBF2UqC;IE1UrC,2BF0U6C;IEzU7C,uBFyUyD;EA2C3D;AACF;AAzCgB;EAZJ;IAaQ,aAAA;EA4ClB;AACF;AA1CgB;EACI,QAAA;EEpVhB,aAAA;EACA,mBFoVqC;EEnVrC,8BFmV0C;EElV1C,mBFkVyD;AA+C7D;AA3CY;EACI,aAAA;AA6ChB;AA3CgB;EACI,QAAA;EE7VhB,aAAA;EACA,mBF6VqC;EE5VrC,8BF4V0C;EE3V1C,mBF2VyD;AAgD7D;AA7CgB;EARJ;IASQ,WAAA;IACA,cAAA;IACA,yBAAA;IACA,sBAAA;IErWhB,aAAA;IACA,mBFqWqC;IEpWrC,8BFoW0C;IEnW1C,mBFmWyD;IE/VzD,yBFgWqC;IE/VrC,cF+VmD;IE9VnD,kBF8VwD;IE7VxD,gBF6VgE;IE5VhE,iBF4VqE;EAuDvE;AACF;AAnDQ;EACI,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,WAAA;EACA,UAAA;EEjXR,aAAA;EACA,mBFiX6B;EEhX7B,8BFgXkC;EE/WlC,mBF+WiD;AAwDrD;AAtDY;EARJ;IASQ,aAAA;IACA,SAAA;IACA,SAAA;IEvXZ,aAAA;IACA,sBFuXiC;IEtXjC,2BFsXyC;IErXzC,uBFqXqD;EA4DvD;AACF;AA1DY;EACI,iDAAA;AA4DhB;AAzDY;EACI,kBAAA;AA2DhB;AAzDgB;EACI,cAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;EE/XhB,yBFgYqC;EE/XrC,cF+XmD;EE9XnD,kBF8XwD;EE7XxD,gBF6XgE;EE5XhE,iBF4XqE;AA+DzE;AA7DoB;EAPJ;IAQQ,WAAA;IEnYpB,yBFoYyC;IEnYzC,eFmYuD;IElYvD,kBFkY6D;IEjY7D,gBFiYqE;IEhYrE,iBFgY0E;EAoE5E;AACF;AAlEoB;EAZJ;IAaO,WAAA;EAqErB;AACF;AAlEgB;EACI,kBAAA;EACA,WAAA;EACA,UAAA;AAoEpB;AAlEoB;EALJ;IAMQ,WAAA;IACA,UAAA;EAqEtB;AACF;AAnEoB;EAVJ;IAWQ,aAAA;EAsEtB;AACF;AAlEY;EACI,cAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EEpaZ,yBFqaiC;EEpajC,eFoa+C;EEna/C,kBFmaqD;EElarD,gBFka6D;EEja7D,iBFiakE;AAwEtE;AAtEgB;EAXJ;IAYQ,YAAA;IExahB,yBFyaqC;IExarC,eFwamD;IEvanD,kBFuayD;IEtazD,gBFsaiE;IErajE,iBFqasE;EA6ExE;AACF;AA3EgB;EAhBJ;IAiBQ,gBAAA;IACA,YAAA;IE9ahB,yBF+aqC;IE9arC,eF8amD;IE7anD,kBF6ayD;IE5azD,gBF4aiE;IE3ajE,iBF2asE;EAkFxE;AACF;;AA1EA;EACI;IACI,UAAA;EA6EN;EA3EE;IACI,UAAA;EA6EN;AACF;AAxEA;EACI;IACI,WAAA;EA0EN;EAxEE;IACI,OAAA;EA0EN;AACF;AAvEA;EACI;IACI,YAAA;EAyEN;EAvEE;IACI,QAAA;EAyEN;AACF;AApEA;EACI;IACE,uBAAA;EAsEJ;EApEE;IACE,yBAAA;EAsEJ;AACF","sourcesContent":["@use '../../styles/mixins.scss';\n@import '../../styles/variables.scss';\n\n.no-scroll {\n    overflow: hidden;\n}\n\n.welcome-section {\n    width: 100%;\n    height: calc(100svh - 92px);\n    padding-top: 92px;\n    color: $white;\n    background-color: $main-color;\n    position: relative;\n    z-index: 2;\n    @include mixins.flex(row, center, center);\n\n    @media (min-width: 1620px) {\n        height: calc(100svh - 100px);\n        padding-top: 100px;\n    }\n\n    @media (max-width: 550px) {\n        height: calc(100svh - 80px);\n        padding-top: 80px;\n    }\n\n    .welcome-section-container {\n        width: calc(100% - 160px);\n        height: 100%;\n        position: relative;\n        overflow: hidden;\n\n        @media (min-width: 1620px) {\n            width: calc(100% - 200px);\n        }\n\n        @media (max-width: 1050px) {\n            width: calc(100% - 80px);\n        }\n\n        @media (max-width: 550px) {\n            width: calc(100% - 32px);\n        }\n\n        .welcome-section-lottie-container {\n            width: 1200px;\n            height: 100%;\n            transform-origin: center center;\n            position: absolute;\n            z-index: 20;\n            bottom: 50px;\n            left: 50%;\n            transform: translateX(-50%) translateY(0) scale(1);\n            transition: transform 1.5s ease-in-out;\n            @include mixins.flex(row, center, center);\n\n            svg {\n                max-width: 100% !important;\n                transform: unset !important;\n            }\n\n            @media (max-width: 1150px) {\n                width: 1000px;\n                bottom: 0;\n            }\n\n            @media (max-width: 950px) {\n                width: 900px;\n            }\n\n            @media (max-width: 750px) {\n                width: 700px;\n            }\n\n            @media (max-width: 650px) {\n                width: 600px;\n            }\n\n            @media (max-width: 550px) {\n                width: 500px;\n                bottom: -6%;\n            }\n\n            @media (max-width: 450px) {\n                width: 100%;\n                height: 80%;\n                bottom: 20%;\n\n                &.scale-modile {\n                    width: 250%;\n                    transform: translateX(-50%) translateY(0) scale(3);\n                }\n            }\n\n            &.scale {\n                transform: translateX(-50%) translateY(-7%) scale(4.5);\n\n                @media (max-width: 650px) {\n                    transform: translateX(-50%) translateY(-7%) scale(7);\n                }\n\n                @media (max-width: 450px) {\n                    transform: translateX(-50%) translateY(22%) scale(3.8);\n                }\n            }\n        }\n\n        .welcome-section-iddle-lottie {\n            max-width: calc(100%) !important;\n            height: 100% !important;\n    \n\n            svg {\n                max-width: 100% !important;\n                transform: unset !important;\n            }\n        }\n\n        .welcome-section-title {\n            position: absolute;\n            top: 69%;\n            z-index: 30;\n            // display: block;\n            // width: 100%;\n            white-space: nowrap;\n            // opacity: 0;\n            overflow: hidden;\n            \n            @include mixins.font(FixelDisplay, 300px, normal, 400, 90%);\n\n            .char {\n                opacity: 0;\n                display: inline-block;\n            }\n\n            @media (min-width: 1620px) {\n                @include mixins.font(FixelDisplay, 400px, normal, 400, 90%);\n            }\n\n            @media (max-width: 550px) {\n                top: unset;\n                bottom: 0;\n                padding-bottom: 90px;\n                transform-origin: bottom left!important;\n            } \n\n            &.visible {\n                animation: visibleText 1s 2s forwards ease-in-out;\n            }\n        }\n\n        .welcome-section-subtitle {\n            position: absolute;\n            top: 48px;\n            left: 50%;\n            z-index: 30;\n            transform: translateX(-50%);\n            text-align: center;\n            text-transform: uppercase;\n            overflow: hidden;\n            opacity: 0;\n            animation: visibleText 1s 12s forwards ease-in-out;\n            @include mixins.font(FixelDisplay, 32px, normal, 500, 100%);\n\n            @media (min-width: 1620px) {\n                @include mixins.font(FixelDisplay, 40px, normal, 500, 100%);\n            }\n\n            @media (max-width: 650px) {\n                @include mixins.font(FixelDisplay, 25px, normal, 500, 100%);\n            }\n\n            @media (max-width: 550px) {\n                width: 100%;\n                top: unset;\n                bottom: 200px;\n                @include mixins.font(FixelDisplay, 16px, normal, 500, 100%);\n            }\n\n            @media (max-width: 400px) {\n                bottom: 150px;\n            }\n\n            .char {\n                opacity: 0;\n                display: inline-block;\n            }\n\n            &.visible {\n                animation: visibleText 1s 2s forwards ease-in-out;\n            }\n        }\n\n        .progress-bar {\n            position: absolute;\n            width: 100%;\n            height: 2px;\n            background-color: $white;\n\n            &.top {\n                top: 22%;\n                transition: top 1s cubic-bezier(0.4, 0, 0.2, 1);\n\n                @media (max-width: 1150px) {\n                    top: 35%;\n                }\n\n                @media (max-width: 450px) {\n                    top: 25%;\n                }\n\n                // @media (max-width: 400px) {\n                //     top: 50%;\n                // }\n\n                &.up-to-header {\n                    top: 0px;\n                }\n\n                &.fixed {\n                    opacity: 0;\n                    transition: opacity 0s linear;\n                }\n            }\n\n            &.bottom {\n                bottom: 35%;\n                transition: bottom 1s cubic-bezier(0.4, 0, 0.2, 1);\n\n                @media (max-width: 550px) {\n                    bottom: 25%;\n                }\n\n                @media (max-width: 450px) {\n                    bottom: 45%;\n\n                    &.down-to-bottom {\n                        bottom: 20%;\n                    }\n                }\n\n                @media (max-width: 400px) {\n                    &.down-to-bottom {\n                        bottom: 17%;\n                    }\n                }\n            }\n        }\n\n        .progress-bar-percentage {\n            position: absolute;\n            left: 0;\n            bottom: 48px;\n            opacity: 1;\n            transition: opacity 0.3s ease-in-out;\n            @include mixins.font(FixelDisplay, 124px, normal, 400, 90%);\n\n            @media (max-width: 550px) {\n                bottom: 30px;\n                @include mixins.font(FixelDisplay, 50px, normal, 400, 90%);\n            }\n\n            &.hidden {\n                opacity: 0;\n            }\n        }\n\n        .welcome-section-star {\n            position: absolute;\n            bottom: 35%;\n            transform: translateY(50%);\n            background-color: $main-color;\n\n            @media (max-width: 550px) {\n                bottom: unset;\n                top: 30px;\n            }\n\n            img {\n                animation: rotatingStar 8s linear infinite;\n            }\n\n            &.left {\n                left: -41px;\n                padding-right: 16px;\n\n                @media (max-width: 550px) {\n                    display: none;\n                }\n\n                &.visible {\n                    animation: visibleLeftStar 1s 1.5s forwards ease-in-out;\n                }\n            }\n\n            &.right {\n                right: -41px;\n                padding-left: 16px;\n\n                &.visible {\n                    animation: visibleRightStar 1s 1.5s forwards ease-in-out;\n                }\n            }\n        }\n\n        .welcome-section-benefits-box {\n            width: 100%;\n            position: absolute;\n            top: 48px;\n            opacity: 0;\n            @include mixins.flex(row, space-between, center);\n\n            @media (max-width: 550px) {\n                top: unset;\n                bottom: 0;\n                padding-bottom: 15px;\n                @include mixins.flex(row, space-between, center);\n            }\n\n            &.visible {\n                animation: visibleText 1s 1s forwards ease-in-out;\n            }\n\n            .welcome-section-benefits-small-box{\n                gap: 38px;\n                text-transform: uppercase;\n                letter-spacing: 0.08px;\n                @include mixins.flex(row, space-between, center);\n                @include mixins.font(FixelDisplay, 8px, normal, 500, 130%);\n\n                @media (max-width: 1300px) {\n                    gap: 4px;\n                    @include mixins.flex(column, flex-start, flex-start);\n                }\n\n                @media (max-width: 550px) {\n                    display: none;\n                }\n\n                .welcome-section-benefit {\n                    gap: 4px;\n                    @include mixins.flex(row, space-between, center);\n                }\n            }\n\n            .welcome-section-benefits-small-box-mobile {\n                display: none;\n\n                .welcome-section-benefit {\n                    gap: 4px;\n                    @include mixins.flex(row, space-between, center);\n                }\n\n                @media (max-width: 550px) {\n                    width: 100%;\n                    display: block;\n                    text-transform: uppercase;\n                    letter-spacing: 0.08px;\n                    @include mixins.flex(row, space-between, center);\n                    @include mixins.font(FixelDisplay, 8px, normal, 500, 130%);\n                }\n            }\n        }\n\n        .welcome-section-text-box {\n            width: 100%;\n            position: absolute;\n            bottom: calc(35% + 21px);\n            z-index: 21;\n            opacity: 0;\n            @include mixins.flex(row, space-between, center);\n\n            @media (max-width: 550px) {\n                bottom: unset;\n                top: 20px;\n                gap: 12px;\n                @include mixins.flex(column, flex-start, flex-start);\n            }\n\n            &.visible {\n                animation: visibleText 1s 1s forwards ease-in-out;\n            }\n\n            .welcome-section-text-box-first {\n                position: relative;\n\n                span {\n                    display: block;\n                    width: 74px;\n                    letter-spacing: 0.08px;\n                    text-transform: uppercase;\n                    @include mixins.font(FixelDisplay, 8px, normal, 500, 130%);\n\n                    @media (min-width: 1620px) {\n                        width: 94px;\n                        @include mixins.font(FixelDisplay, 10px, normal, 500, 130%);\n                    }\n\n                    @media (max-width: 550px) {\n                       width: 100%;\n                    }\n                }\n\n                svg {\n                    position: absolute;\n                    bottom: 3px;\n                    left: 25px;\n\n                    @media (min-width: 1620px) {\n                        bottom: 4px;\n                        left: 29px;\n                    }\n\n                    @media (max-width: 550px) {\n                        display: none;\n                    }\n                }\n            }\n\n            .welcome-section-text-box-second {\n                display: block;\n                width: 221px;\n                letter-spacing: 0.14px;\n                text-transform: uppercase;\n                position: absolute;\n                top: 0;\n                right: 0;\n                z-index: 50;\n                @include mixins.font(FixelDisplay, 14px, normal, 500, 110%);\n\n                @media (min-width: 1620px) {\n                    width: 253px;\n                    @include mixins.font(FixelDisplay, 16px, normal, 500, 110%);\n                }\n\n                @media (max-width: 550px) {\n                    position: static;\n                    width: 298px;\n                    @include mixins.font(FixelDisplay, 18px, normal, 500, 100%);\n                }\n            }\n        }\n    }\n}\n\n// Visible Text Animation\n\n@keyframes visibleText {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n} \n\n// Left And Right Stars Animations\n\n@keyframes visibleLeftStar {\n    from {\n        left: -41px;\n    }\n    to {\n        left: 0;\n    }\n} \n\n@keyframes visibleRightStar {\n    from {\n        right: -41px;\n    }\n    to {\n        right: 0;\n    }\n} \n\n// Stars Rotating Animation\n\n@keyframes rotatingStar {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }","// Colors\n\n$main-color: #982D67;\n$white: #FFFFFF;\n$light-background: #F5F5F5;\n$purple: #812456;\n$grey: #EAEAEA;\n$grey-opacity:#E0E0E0;\n$grey-dark: #575756;\n$grey-text: #BCBCBC;\n$dark: #313130;\n$red: #AE2323;\n$opacity-text: rgba(255, 255, 255, 0.50);","@mixin flex($dir, $jc, $ai) {\n    display: flex;\n    flex-direction: $dir;\n    justify-content: $jc;\n    align-items: $ai;\n}\n\n@mixin font ($font, $size, $style, $weight, $height) {\n    font-family: $font;\n    font-size: $size;\n    font-style: $style;\n    font-weight: $weight;\n    line-height: $height;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
